// Datentypen und Formatierer der Selbstauskunft-Seite (aus SelbstauskunftListe herausgelöst, unverändert).
import type { SelbstauskunftStatus } from '../../../../lib/selbstauskunft/status';

export interface Person {
  name?: string;
  geburtsdatum?: string;
  verhaeltnis?: string;
}

export interface SelbstauskunftDaten {
  anrede?: string; vorname?: string; nachname?: string; geburtsdatum?: string;
  strasse?: string; plz?: string; ort?: string; telefon?: string; email?: string; familienstand?: string;
  personen?: Person[];
  beruf?: string; arbeitgeber?: string; arbeitgeber_ort?: string; beschaeftigt_seit?: string;
  beschaeftigungsart?: string;
  netto_einkommen?: string;
  weitere_einkuenfte?: string;
  mietverhaeltnis?: { wohnhaft_seit?: string; vermieter_name?: string; vermieter_kontakt?: string; gekuendigt?: boolean; mietrueckstaende?: boolean };
  erklaerungen?: { mietschulden?: boolean; raeumungsklage?: boolean; insolvenz?: boolean; lohnpfaendung?: boolean };
  haustiere?: string; raucher?: boolean; musikinstrumente?: string;
  einzugstermin?: string; nachricht?: string;
  einwilligung_datenschutz?: boolean; wahrheitserklaerung?: boolean;
}

export interface Eingang {
  id: string;
  link_id: string | null;
  objekt_id: string | null;
  einheit_id: string | null;
  name: string;
  email: string;
  telefon: string | null;
  daten: SelbstauskunftDaten;
  status: SelbstauskunftStatus;
  notiz_intern: string | null;
  kontakt_id: string | null;
  created_at: string;
  objekt?: { id: string; bezeichnung: string } | null;
  einheit?: { id: string; bezeichnung: string } | null;
}

export const BESCHAEFTIGUNGSART_LABEL: Record<string, string> = {
  unbefristet: 'Unbefristet angestellt',
  befristet: 'Befristet angestellt',
  selbststaendig: 'Selbstständig',
  rente: 'Rente',
  studium_ausbildung: 'Studium / Ausbildung',
  arbeitssuchend: 'Arbeitssuchend',
};

export const formatDatum = (d: string | null | undefined): string => {
  if (!d) return '—';
  const date = new Date(d.length <= 10 ? `${d}T12:00:00` : d);
  if (Number.isNaN(date.getTime())) return d;
  return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
};

export const wert = (v: string | null | undefined): string => (v && v.trim() ? v : '—');

/** Personen im Haushalt = Antragsteller + eingetragene Mitziehende. */
export const personenzahl = (e: Eingang): number => 1 + (e.daten?.personen?.length || 0);

export const objektZeile = (e: Eingang): string =>
  `${e.objekt?.bezeichnung || 'Kein Objekt'}${e.einheit?.bezeichnung ? ` · ${e.einheit.bezeichnung}` : ''}`;
